import { get } from 'aws-amplify/api'

import errorTrackingService from '../services/errorTrackingService'
import { isGuestFlowServerErrorStatus } from './scheduleGuestFlow'

const ENDPOINT = '/auth/verifyOnboardingStatus'

/** Returning patients can continue scheduling; others need /calendario/registro. */
export const getScheduleOnboardingRedirect = (resp) => {
  const redirect = resp?.data?.redirect ?? resp?.redirect
  if (typeof redirect !== 'string') return null
  return redirect.trim()
}

export const isScheduleOnboardingComplete = (resp) => {
  const redirect = getScheduleOnboardingRedirect(resp)
  if (!redirect) return false

  const pathname = redirect.split('?')[0].replace(/\/$/, '')
  return pathname === '/calendario'
}

export const fetchVerifyOnboardingStatus = async (idToken) => {
  if (!idToken?.__raw) return undefined

  try {
    const resp = get({
      apiName: process.env.REACT_APP_API_BASE_URL,
      path: ENDPOINT,
      options: {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${idToken.__raw}`
        }
      }
    })
    const { body } = await resp.response
    const data = await body.json()

    if (data.success === false) {
      const error = new Error(data.message || 'API returned success: false')
      error.isAPIError = true
      error.response = { status: 200, data }
      errorTrackingService.trackAPIError(error, ENDPOINT, 'GET')
      return undefined
    }

    return data
  } catch (error) {
    const statusCode = Number(
      error?.response?.statusCode ??
      error?.$metadata?.httpStatusCode ??
      error?.underlyingError?.response?.statusCode
    )
    errorTrackingService.trackAPIError(error, ENDPOINT, 'GET')
    if (isGuestFlowServerErrorStatus(statusCode)) {
      return { isServerError: true, status: statusCode }
    }
    return undefined
  }
}
